module.exports = __webpack_public_path__ + "fonts/baronsans-ultrathin-webfont.745f7f81.woff";